module.exports = __webpack_public_path__ + "img/team.68bafd48.jpg";